import { hydrateRoot } from 'react-dom/client';
import { IntlProvider } from 'dibs-react-intl';
import { ReactRelayContext } from 'react-relay/legacy';
import serverVars from 'server-vars';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import { shopRoot } from '../shop/shopRoot';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import * as tracking from 'dibs-tracking';
import { ShopWrapper } from '../shop/ShopWrapper';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import get from 'lodash/get';

const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));
const variables = serverVars.get('relayVariables');

const operation = createOperationDescriptor(getRequest(shopRoot), variables);
const snapshot = environment.lookup(operation.fragment);
const { data } = snapshot;

initializeDBL().then(() => {
    hydrateRoot(
        document.getElementById('js-root'),
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            <ReactRelayContext.Provider
                value={{
                    environment,
                    variables: snapshot.variables || {},
                }}
            >
                <ShopWrapper landingPage={get(data, 'viewer.landingPage')} />
            </ReactRelayContext.Provider>
        </IntlProvider>
    );
    tracking.trackPageview();
});
